import Tokens from '@zapier/design-tokens';

const Colors = {
  GrayWarm1: Tokens.GrayWarm1,
  GrayWarm2: Tokens.GrayWarm2,
  GrayWarm3: Tokens.GrayWarm3,
  GrayWarm4: Tokens.GrayWarm4,
  GrayWarm5: Tokens.GrayWarm5,
  GrayWarm6: Tokens.GrayWarm6,
  GrayWarm7: Tokens.GrayWarm7,
  GrayWarm8: Tokens.GrayWarm8,
  GrayWarm9: Tokens.GrayWarm9,
  GrayWarm10: Tokens.GrayWarm10,
  BrandOrange: Tokens.BrandOrange,
  BrandEarth: Tokens.BrandEarth,
  BrandLavender: Tokens.BrandLavender,
  BrandNight: Tokens.BrandNight,
  BrandAlmostWhite: Tokens.BrandAlmostWhite,
  BrandPeach: Tokens.BrandPeach,
  BrandCream: Tokens.BrandCream,
  BrandBolt: Tokens.BrandBolt,
  BrandSky: Tokens.BrandSky,
  BrandMoss: Tokens.BrandMoss,
  Purple1: Tokens.ColorPurple1,
  Purple2: Tokens.ColorPurple2,
  Purple3: Tokens.ColorPurple3,
  Purple4: Tokens.ColorPurple4,
  Purple5: Tokens.ColorPurple5,
  Yellow1: Tokens.ColorYellow1,
  Yellow2: Tokens.ColorYellow2,
  Yellow3: Tokens.ColorYellow3,
  Yellow4: Tokens.ColorYellow4,
  Yellow5: Tokens.ColorYellow5,
  Red1: Tokens.ColorRed1,
  Red2: Tokens.ColorRed2,
  Red3: Tokens.ColorRed3,
  Red4: Tokens.ColorRed4,
  Red5: Tokens.ColorRed5,
  Blue1: Tokens.ColorBlue1,
  Blue2: Tokens.ColorBlue2,
  Blue3: Tokens.ColorBlue3,
  Blue4: Tokens.ColorBlue4,
  Blue5: Tokens.ColorBlue5,
  Orange1: Tokens.ColorOrange1,
  Orange2: Tokens.ColorOrange2,
  Orange3: Tokens.ColorOrange3,
  Orange4: Tokens.ColorOrange4,
  Orange5: Tokens.ColorOrange5,
  Teal1: Tokens.ColorTeal1,
  Teal2: Tokens.ColorTeal2,
  Teal3: Tokens.ColorTeal3,
  Teal4: Tokens.ColorTeal4,
  Teal5: Tokens.ColorTeal5,
  Green1: Tokens.ColorGreen1,
  Green2: Tokens.ColorGreen2,
  Green3: Tokens.ColorGreen3,
  Green4: Tokens.ColorGreen4,
  Green5: Tokens.ColorGreen5,
  Pink1: Tokens.ColorPink1,
  Pink2: Tokens.ColorPink2,
  Pink3: Tokens.ColorPink3,
  Pink4: Tokens.ColorPink4,
  Pink5: Tokens.ColorPink5,
  PrimeWhite: Tokens.PrimeWhite,
  PrimeBlack: Tokens.PrimeBlack,
  PrimePurple: Tokens.PrimePurple,
  PrimeBlue: Tokens.PrimeBlue,
  PrimeTeal: Tokens.PrimeTeal,
  PrimeGreen: Tokens.PrimeGreen,
  PrimeYellow: Tokens.PrimeYellow,
  PrimeOrange: Tokens.PrimeOrange,
  PrimeRed: Tokens.PrimeRed,
  PrimePink: Tokens.PrimePink,
  UiBrandWeakest: Tokens.UiBrandWeakest,
  UiBrandWeaker: Tokens.UiBrandWeaker,
  UiBrand: Tokens.UiBrand,
  UiBrandStronger: Tokens.UiBrandStrongest,
  UiBrandStrongest: Tokens.UiBrandStrongest,
  UiPrimaryWeakest: Tokens.UiPrimaryWeakest,
  UiPrimaryWeaker: Tokens.UiPrimaryWeaker,
  UiPrimary: Tokens.UiPrimary,
  UiPrimaryStronger: Tokens.UiPrimaryStronger,
  UiPrimaryStrongest: Tokens.UiPrimaryStrongest,
  StatusWarningWeakest: Tokens.StatusWarningWeakest,
  StatusWarningWeaker: Tokens.StatusWarningWeaker,
  StatusWarning: Tokens.StatusWarning,
  StatusWarningStronger: Tokens.StatusWarningStronger,
  StatusWarningStrongest: Tokens.StatusWarningStrongest,
  StatusErrorWeakest: Tokens.StatusErrorWeakest,
  StatusErrorWeaker: Tokens.StatusErrorWeaker,
  StatusError: Tokens.StatusError,
  StatusErrorStronger: Tokens.StatusErrorStronger,
  StatusErrorStrongest: Tokens.StatusErrorStrongest,
  StatusSuccessWeakest: Tokens.StatusSuccessWeakest,
  StatusSuccessWeaker: Tokens.StatusSuccessWeaker,
  StatusSuccess: Tokens.StatusSuccess,
  StatusSuccessStronger: Tokens.StatusSuccessStronger,
  StatusSuccessStrongest: Tokens.StatusSuccessStrongest,
  BackgroundWeaker: Tokens.BackgroundWeaker,
  BackgroundDefault: Tokens.BackgroundDefault,
  BackgroundStronger: Tokens.BackgroundStronger,
  BackgroundStrongest: Tokens.BackgroundStrongest,
  BackgroundSelected: Tokens.BackgroundSelected,
  BackgroundOverlay: Tokens.BackgroundOverlay,
  StrokeWeaker: Tokens.StrokeWeaker,
  StrokeDefault: Tokens.StrokeDefault,
  StrokeStronger: Tokens.StrokeStronger,
  StrokeSelected: Tokens.StrokeSelected,
  ReservedBeta: Tokens.ReservedBeta,
  ReservedInvite: Tokens.ReservedInvite,
  ReservedFree: Tokens.ReservedFree,
  TextWeakest: Tokens.TextWeakest,
  TextWeaker: Tokens.TextWeaker,
  TextDefault: Tokens.TextDefault,
  TextStronger: Tokens.TextStronger,
  TextLink: Tokens.TextLink,
  TextLinkHover: Tokens.TextLinkHover,
  TextInverted: Tokens.TextInverted,
  // special colors
  transparent: "transparent",
  inherit: "inherit",
  currentColor: "currentColor"
};

export { Colors };
//# sourceMappingURL=Colors.es.js.map
